import qualificationsImage from "../../assets/images/Galéria 12.jpg";
import SectionHeading from "../shared/SectionHeading";
import "./QualificationsSection.css";

const qualifications = [
  "Gyógytornász-fizioterapeuta",
  "Manuálterapeuta",
  "Kinesio tape terapeuta",
  'McKenzie "A" és "B" tanfolyam',
  "Gerinc- és tartásjavító prevenciós szemlélet",
  "Folyamatos szakmai továbbképzések",
];

function QualificationsSection() {
  return (
    <section className="qualifications-section">
      <img
        className="qualifications-section__image"
        src={qualificationsImage}
        alt=""
        aria-hidden="true"
      />

      <div className="qualifications-section__overlay" aria-hidden="true" />

      <div className="qualifications-section__inner">
        <SectionHeading
          eyebrow="Képzéseim"
          title="Folyamatos szakmai fejlődés"
          centered
        />

        <ul className="qualifications-list">
          {qualifications.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default QualificationsSection;
